module.exports = {
    props: ['user', 'teams'],
    /**
     * The component's data.
     */
    data() {
        return {

        };
    },


    /**
     * Prepare the component.
     */
    mounted() {
        console.log('in mount')
    },


    /**
     * The component has been created by Vue.
     */
    created() {

    },


    methods: {
        /**
         * Get all of the available token abilities.
         */
    }
};
